/**
 * @typedef {{ itemID: number | null, itemName: string }} UnavailableLineItem
 */

/**
 * Parse per-item stock rows from checkCart `detail` (Flutter parity).
 * @param {Record<string, unknown> | null} detail
 * @returns {UnavailableLineItem[]}
 */
export function parseUnavailableLineItems(detail) {
  if (!detail || typeof detail !== 'object') return [];
  const rows = detail.data;
  if (!Array.isArray(rows)) return [];

  return rows
    .filter((row) => row && typeof row === 'object' && !/** @type {{ availability?: boolean }} */ (row).availability)
    .map((row) => {
      const safe = /** @type {Record<string, unknown>} */ (row);
      const rawId = safe.itemID ?? safe.itemId ?? safe.id;
      const id = rawId != null && rawId !== '' ? Number(rawId) : null;
      return {
        itemID: Number.isFinite(id) ? id : null,
        itemName: String(safe.itemName ?? safe.name ?? '').trim(),
      };
    })
    .filter((row) => row.itemID != null || row.itemName);
}

/**
 * @param {UnavailableLineItem[]} lines
 */
export function buildUnavailableLookup(lines) {
  const ids = new Set();
  const names = [];
  for (const line of lines) {
    if (line.itemID != null) ids.add(line.itemID);
    if (line.itemName) names.push(line.itemName);
  }
  return { ids, names };
}

/**
 * @param {{ id: number, name?: string }} cartItem
 * @param {{ ids: Set<number>, names: string[] }} lookup
 */
export function isCartItemUnavailable(cartItem, lookup) {
  const id = Number(cartItem.id);
  if (Number.isFinite(id) && lookup.ids.has(id)) return true;

  const cartName = String(cartItem.name || '').trim();
  if (!cartName) return false;

  for (const apiName of lookup.names) {
    if (!apiName) continue;
    if (cartName === apiName) return true;
    if (cartName.toLowerCase() === apiName.toLowerCase()) return true;
    if (cartName.includes(apiName) || apiName.includes(cartName)) return true;
  }
  return false;
}
